<template>
  <div>
    <el-card>
      <el-steps :active="activeStep" align-center finish-status="success">
        <el-step :title="$t('form.activity.basicActivitySettings')"></el-step>
        <el-step :title="$t('form.activity.activityProductManagement')"></el-step>
      </el-steps>
      <el-divider />
      <div>
        <router-view :setActiveStep="setActiveStep" />
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  data () {
    return {
      activeStep: 0
    }
  },
  methods: {
    setActiveStep (index) {
      const _this = this
      _this.activeStep = index
    }
  }
}
</script>

<style lang="scss">
</style>
